import React, { useState } from "react";
import { Button, Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import TableChartIcon from "@mui/icons-material/TableChart";

function ExportButtons({ onExportPDF, onExportExcel }) {
	const [anchorEl, setAnchorEl] = useState(null);

	return (
		<>
			<Button
				variant="outlined"
				size="small"
				startIcon={<FileDownloadIcon />}
				onClick={(e) => setAnchorEl(e.currentTarget)}
				sx={{ borderColor: "#dfe3e8", color: "#0f4557", textTransform: "none", borderRadius: "8px" }}
			>
				Exportar
			</Button>
			<Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
				<MenuItem onClick={() => { onExportPDF(); setAnchorEl(null); }}>
					<ListItemIcon><PictureAsPdfIcon fontSize="small" sx={{ color: "#dc2626" }} /></ListItemIcon>
					<ListItemText>Exportar PDF</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => { onExportExcel(); setAnchorEl(null); }}>
					<ListItemIcon><TableChartIcon fontSize="small" sx={{ color: "#1a9e8f" }} /></ListItemIcon>
					<ListItemText>Exportar Excel</ListItemText>
				</MenuItem>
			</Menu>
		</>
	);
}

export default ExportButtons;
